import React from 'react';
import { useSelector } from 'react-redux';
import Rotas from '../routes/rotas';

export default function Header() {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const isRefreshingAfterLogin = Boolean(sessionStorage.getItem('elocoto:refresh-after-login'));
  const showAuthenticatedLayout = isLoggedIn && !isRefreshingAfterLogin;

  return (
    <div className={showAuthenticatedLayout ? 'app-shell' : 'auth-shell'}>
      {showAuthenticatedLayout ? (
        <div className="app-workspace">
          <main className="app-content" role="main"><Rotas /></main>
        </div>
      ) : (
        <main className="auth-content">
          <section className="auth-intro">
            <img src="logo.png" alt="Elo Sistemas" className="auth-logo" />
            <span className="auth-eyebrow">Gestão inteligente</span>
            <h1>Conectando pessoas, soluções e tecnologia.</h1>
            <p>Conecte compradores e vendedores em um ambiente único, seguro e eficiente.</p>
            <div className="auth-feature-list">
              <span><i className="pi pi-check-circle" /> Informações centralizadas</span>
              <span><i className="pi pi-check-circle" /> Cotações mais produtivas</span>
              <span><i className="pi pi-check-circle" /> Acesso protegido</span>
            </div>
          </section>
          <section className="auth-panel">
            <div className="auth-route"><Rotas /></div>
            <span className="auth-version">Elo Sistemas · Versão 2.0.3</span>
          </section>
        </main>
      ) }
    </div>
  );
}
